export default __webpack_public_path__ + "static/wall-416060_1280-b911639361cc89ec4bd118f2ea845a19.png";